import {
  GET_VIDEO_RESUME, GET_VIDEO_RESUME_SUCCESSFULL, GET_VIDEO_RESUME_FAILED
} from "./actionTypes"

const initialState = {
  loader: false,
  data: {},
  errorMessage: ""
}

const videoResumeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VIDEO_RESUME:
      state = {
        ...state,
        loader: true,
        data: {},
        errorMessage: ""
      }
      break
    case GET_VIDEO_RESUME_SUCCESSFULL:
      state = {
        ...state,
        loader: false,
        data: action.payload
      }
      break
    case GET_VIDEO_RESUME_FAILED:
      state = {
        ...state,
        loader: false,
        errorMessage: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default videoResumeReducer